<template>
    <!---------------------------------

        Table of Content:

        1. Client Side: the client rate the project
        2. Worker Side: the worker upload the project
            - Upload Image Step 1: Преди потребителят да е качил изображение
            - Upload Image Step 2: След като е селектирал изображение за качване

    ----------------------------------->

    <div>
        <!-- 1. Client Side: the client rate the project -->
        <div class="row">
            <div class="col-xl-9 col-lg-8 p-0 mb-0 mb-lg-5 pb-0 pb-lg-4">
                <div class="d-flex justify-content-center">
                    <button id="" class="btn btn-outline-primary btn-rate-menu">
                        <span class="icon icon-thumbs-up"></span>
                        Оцени предложението
                    </button>
                </div>
                <div class="concept-header" style="background-image: url(/resources/images/img-ideen-proekt.jpg);">
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-xl-7 col-lg-10 col-md-10">
                        <div class="page-header-info page-header-concept shadow-lg pl-4 pr-4 pt-4 mb-5 text-center">
                            <h1 class="mt-3 mb-2">
                                Предложение за обзавеждане на малък апартамент
                            </h1>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <div class="breadcrumbs">
                                        <a href="/">Начало</a>
                                            <span>
                                                <span class="separator">/</span>
                                                <a href="#">Моите проекти</a>     
                                            </span>
                                            <span>
                                                <span class="separator">/</span>
                                                <a href="#">Реновиране на тристаен апартамент</a>
                                            </span>
                                            <span>
                                            <span class="separator">/</span>
                                            <a href="#">Предложение за обзавеждане на малък апартамент</a>                     
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="row page-header-bottom">
                                <div class="col-12 text-center">
                                    <a class="btn btn-secondary btn-lg" href="#">
                                        <span class="icon icon-grid"></span>
                                        Всички предложения
                                    </a>
                                </div>
                            </div>
                        </div>                            
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-md-10 text-center">
                        <p class="sub-title text-center">идеен проект за</p>
                        <h2 class="title text-orange">
                            Реновиране на тристаен апартамент
                        </h2>                        
                    </div>                    
                </div>

                <div class="row justify-content-center">
                    <div class="col-xl-10 col-lg-11 col-11">
                        <div id="module" class="container">
                            <div class="collapse" id="collapseExample" aria-expanded="false">
                                <p>
                                    Bacon ipsum dolor amet doner picanha tri-tip biltong leberkas salami meatball tongue filet mignon landjaeger tail. Kielbasa salami tenderloin picanha spare ribs, beef ribs strip steak jerky cow. Pork chop chicken ham hock beef ribs turkey jerky. Shoulder Bacon ipsum dolor amet doner picanha tri-tip biltong leberkas salami meatball tongue filet mignon landjaeger tail. Kielbasa salami tenderloin picanha spare ribs, beef ribs strip steak jerky cow. Pork chop chicken ham hock beef ribs turkey jerky. Shoulder
                                </p>
                                <p>
                                    Leef capicola doner, tongue tail sausage short ribs andouille. Rump frankfurter landjaeger t-bone, kielbasa doner ham hock shankle venison. Cupim capicola kielbasa t-bone, ball tip chicken andouille venison pork chop doner bacon beef ribs kevin shankle.
                                </p>
                                <p>
                                    Bacon ipsum dolor amet doner picanha tri-tip biltong leberkas salami meatball tongue filet mignon landjaeger tail. Kielbasa salami tenderloin picanha spare ribs, beef ribs strip steak jerky cow. Pork chop chicken ham hock beef ribs turkey jerky. Shoulder
                                </p>
                                <p>
                                    Leef capicola doner, tongue tail sausage short ribs andouille. Rump frankfurter landjaeger t-bone, kielbasa doner ham hock shankle venison. Cupim capicola kielbasa t-bone, ball tip chicken andouille venison pork chop doner bacon beef ribs kevin shankle.
                                </p>
                                <p>
                                    Bacon ipsum dolor amet doner picanha tri-tip biltong leberkas salami meatball tongue filet mignon landjaeger tail. Kielbasa salami tenderloin picanha spare ribs, beef ribs strip steak jerky cow. Pork chop chicken ham hock beef ribs turkey jerky. Shoulder
                                </p>
                                <p>
                                    Leef capicola doner, tongue tail sausage short ribs andouille. Rump frankfurter landjaeger t-bone, kielbasa doner ham hock shankle venison. Cupim capicola kielbasa t-bone, ball tip chicken andouille venison pork chop doner bacon beef ribs kevin shankle.
                                </p>
                                <p>
                                    Bacon ipsum dolor amet doner picanha tri-tip biltong leberkas salami meatball tongue filet mignon landjaeger tail. Kielbasa salami tenderloin picanha spare ribs, beef ribs strip steak jerky cow. Pork chop chicken ham hock beef ribs turkey jerky. Shoulder
                                </p>
                                <p>
                                    Leef capicola doner, tongue tail sausage short ribs andouille. Rump frankfurter landjaeger t-bone, kielbasa doner ham hock shankle venison. Cupim capicola kielbasa t-bone, ball tip chicken andouille venison pork chop doner bacon beef ribs kevin shankle.
                                </p>  
                            </div>

                            <div class="collapse-bottom text-center mt-3">
                                <a role="button" class="collapsed btn btn-outline-primary btn-lg" data-toggle="collapse" href="#collapseExample" aria-expanded="false" aria-controls="collapseExample">    
                                    <span class="show-less">Покажи по-малко</span>                        
                                    <span class="show-more">Покажи повече</span>
                                    <span class="icon icon-chevron-down mr-0"></span>
                                </a>
                            </div>
                        </div>

                        <div class="row mt-5 ml-3 mr-3 ml-lg-0 mr-lg-0">
                            <div class="col-6 col-md-4 col-lg-3 pb-4" v-for="n in 8">
                                <a class="lp-box-link" href="/resources/images/static/1.jpg" data-lightbox="final">
                                    <img src="/resources/images/static/1.jpg" alt="Project Image">
                                    <span class="overlay d-flex align-items-center justify-content-center">
                                        <span class="icon icon-zoom-in"></span>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>           
            </div>
            <div class="col-xl-3 col-lg-4 p-0">
                <div class="rate-sidebar shadow-lg project-timeline-holder">
                    <div class="responsive-project-title d-flex justify-content-between align-items-center">
                        <h6>Оцени предложението</h6>
                        <span id="close-timeline" class="icon icon-x"></span>
                    </div>
                    <div class="rate-title pl-4 pr-4 pt-4">
                        <p class="sub-title">оцени това</p>
                        <h2 class="title text-left mb-2">Предложение</h2>
                    </div>

                    <div class="rate-items-holder pl-4 pr-4">
                        <ol v-for="n in 5" class="list-group rate-items">
                            <li class="list-group-item rate-item border-top-0 border-left-0 
                                border-right-0 pl-2 pr-2 pt-2 pb-2">
                                <div class="d-flex w-100 align-items-start">
                                    <div class="rate-num mr-2">{{ n }}.</div>
                                    <div class="question mt-2">
                                        В каква степен това предложение отговаря на изискванията ти за стил?
                                    </div>
                                </div>

                                <div class="d-flex">
                                    <div class="rate-slider w-100">
                                        <input type="range" class="custom-range pl-0 pr-0" min="1" max="5" step="0.5" id="customRange3">
                                        <ol class="rate-scale d-flex justify-content-between">
                                            <li><span class="icon icon-thumbs-down"></span></li>
                                            <li>2</li>
                                            <li>3</li>
                                            <li>4</li>
                                            <li><span class="icon icon-thumbs-up"></span></li>
                                        </ol>
                                    </div>

                                    <div class="rate-result flex-shrink-1 ml-2">3.5</div>
                                </div>
                            </li>
                        </ol>
                    </div>

                    <div class="sidebar-bottom pr-4 pl-4 shadow">
                        <div class="final-rating-holder d-flex align-items-center pt-3 pb-0">
                            <span class="rate-result final-rating flex-shrink-1 mt-1">3.3</span>
                            <button class="btn btn-primary btn-block ml-3">
                                <span class="icon icon-check"></span>
                                Постави тази оценка
                            </button>                      
                        </div>

                        <div class="winner-select text-center pt-0 pb-4">
                            <div class="or-sep">
                                <span>или</span>
                            </div>
                            <button class="btn btn-outline-primary btn-block">
                                Това е победителят!
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 2. Worker Side: the worker upload the project -->
        <div class="col-12 p-0 mb-0 mb-lg-5 pb-0 pb-lg-4">

            <!--------------------------------------
                         Upload Image Step 1
            ---------------------------------------->
            <div class="concept-header upload-image">
                <input type="file" id="input-file-now" class="file-upload" />
                <div class="upload-label text-center d-flex align-items-center justify-content-center">
                    <div>
                        <span class="icon icon-upload-cloud d-block mb-2"></span>
                        <h3>Качи главно изображение</h3>
                        <p class="mb-0">За да качиш главно изображение, кликни тук.</p>
                        <small>Разрешени формати: jpg, jpeg, png</small>
                    </div>
                </div>
            </div>

            <!--------------------------------------
                         Upload Image Step 2
            ---------------------------------------->
            <div class="concept-header upload-image change-image" style="display: none; background-image: url(/resources/images/img-ideen-proekt.jpg);">
                <input type="file" id="input-file-now" class="file-upload" />
                <div class="change-label">
                    <span class="icon icon-settings"></span>
                    Промени изображението
                </div>
            </div>

            <!-- end of Uploda Image Steps -->

            <div class="row d-flex justify-content-center">
                <div class="col-xl-6 col-lg-10 col-md-10">
                        <div class="page-header-info page-header-concept page-header-upload shadow-lg pl-4 pr-4 pt-4 mb-5 text-center">
                            <div class="form-group form-name">
                                <label for="name">
                                    <span class="icon icon-settings"></span>
                                </label>
                                <input id="name" class="form-control" placeholder="Името на твоето предложение"></input>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <div class="breadcrumbs">
                                        <a href="/">Начало</a>
                                            <span>
                                                <span class="separator">/</span>
                                                <a href="#">Активни проекти</a>     
                                            </span>
                                            <span>
                                                <span class="separator">/</span>
                                                <a href="#">Реновиране на тристаен апартамент</a>
                                            </span>
                                            <span>
                                            <span class="separator">/</span>
                                            <a href="#">Участвай</a>                     
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="row page-header-bottom">
                                <div class="col-12 text-center">
                                    <a class="btn btn-secondary btn-lg" href="#">
                                        <span class="icon icon-arrow-left"></span>
                                        Към заданието
                                    </a>
                                </div>
                            </div>
                        </div>                            
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-md-10 text-center">
                        <p class="sub-title text-center">идеен проект за</p>
                        <h2 class="title text-orange">
                            Реновиране на тристаен апартамент
                        </h2>                        
                    </div>                    
                </div>

                <div class="container container-lg">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label for="desc">Описание на твоето предложеине:</label>
                                <textarea id="desc" class="form-control" rows="10"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-12">
                            <div class="upload-images p-4">
                                <input type="file" id="input-file-now" class="file-upload" multiple="multiple" />
                                <div class="upload-label text-center d-flex align-items-center justify-content-center">
                                    <div>
                                        <span class="icon icon-upload-cloud d-block mb-2"></span>
                                        <h5 class="mb-0">Качи изображения</h5>
                                        <p class="mb-0">За да качиш изображения, кликни тук. Можеш да качиш няколко изображения едновременно.</p>
                                        <small>Разрешени формати: jpg, jpeg, png, dwg</small>
                                    </div>
                                </div>
                            </div>
                        </div>                                    
                    </div>

                    <div class="row mt-4">
                        <div class="col-6 col-md-4 col-lg-3 pb-4" v-for="n in 8">
                           <a class="lp-box-link" href="/resources/images/static/1.jpg" data-lightbox="final">
                                <img src="/resources/images/static/1.jpg" alt="Project Image">
                                <span class="overlay d-flex align-items-center justify-content-center">
                                    <span class="icon icon-zoom-in"></span>
                                </span>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-12 text-center">
                            <button class="btn btn-primary btn-lg">
                                Изпрати предложението
                                <span class="icon icon-chevrons-right"></span>
                            </button>
                        </div>  
                    </div>
                </div>        
        </div>

    </div>
</template>

<script>
    export default {

        mounted() {
            $("body").addClass('project-rate'); 
        },

        created() {
           
        },

        data() {
            
            return {

                page : 'auction',
                isReady : false,

            }

        },

        methods : {

        }

    }
</script>
